<template>
    <div>
        <!-- delete-dialog -->
        <delete-dialog
            ref="deleteDialog"
            @on-delete="fetchAll"
            :success-message="$t('message.data-is-deleted')"
        >
            {{ $t('are-you-sure-you-want-to') }} <span class="red--text">{{ $t('delete') }}</span> {{ $t('Vacations.this-vacation') + $t('?')}}
        </delete-dialog>
        <!-- dialog add vacations -->
        <v-dialog
            v-model="dialog"
            width="450"
            @keydown.esc="dialog = false"
        >
            <v-card>
                <div class="d-flex justify-end py-1 background-title-card ">
                    <v-card-title
                        class="text-uppercase text-subtitle-1 d-flex justify-center w-100 px-0 py-0 white--text"
                    >
                        {{ vacationId ? $t('Vacations.edit-vacation') : $t('Vacations.add-vacation') }}
                    </v-card-title>
                </div>

                <v-form ref="form" @submit.prevent="submit">
                    <v-card-text class="pt-1 px-3 pb-0">
                        <v-row class="ma-1">
                            <v-col class="pa-1" cols="6">
                                <bee-date-picker
                                    v-model="dataDialog.fromDate"
                                    :input-label="$t('inputs.start-date')"
                                    menu-picker
                                    dense
                                    hide-details
                                    :input-props="{
                                        outlined: true,
                                        dense: true,
                                        clearable: true
                                    }"
                                    :allowed-dates="disableDates"
                                    :disabled="loading"
                                    months-over-max="1"
                                    :rules="rules.required"
                                ></bee-date-picker>
                                <!-- const day = new Date(date).getDay();
                                        if(isDisabledFriday) {
                                            return day !== 5
                                        } else {
                                            return day !== -1
                                        } -->
                            </v-col>
                            <v-col class="pa-1" cols="6">
                                <bee-date-picker
                                    v-model="dataDialog.toDate"
                                    :input-label="$t('inputs.end-date')"
                                    menu-picker
                                    dense
                                    hide-details
                                    :input-props="{
                                        outlined: true,
                                        dense: true,
                                        clearable: true
                                    }"
                                    :allowed-dates="disableDates"
                                    :disabled="loading"
                                    months-over-max="1"
                                    :rules="rules.required"
                                ></bee-date-picker>
                            </v-col>
                            <v-col class="pa-1" cols="8">
                                <v-textarea 
                                    v-model="dataDialog.description"
                                    rows="2"
                                    dense
                                    outlined
                                    hide-details
                                    :label="$t('inputs.description')"
                                    :rules="rules.required"
                                />
                            </v-col>
                            <v-col class="pa-1" cols="4" align-self="center">
                                <v-checkbox 
                                    v-model="dataDialog.isConstant"
                                    dense
                                    hide-details
                                    :true-value="true"
                                    :label="$t('Vacations.is-constant')"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="success"
                            text
                            type="submit"
                            :loading="submitLoading"
                            :disabled="submitLoading"
                            class="text-capitalize"
                        >
                            {{$t('save')}}
                        </v-btn>
                        <v-btn
                            color="grey darken-1"
                            text
                            @click="dialog = false"
                            :disabled="submitLoading"
                            class="text-capitalize"
                        >
                            {{$t('close')}}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- filter -->
        <v-row class="my-1">
            <v-col cols="auto" class="py-0">
                <v-radio-group
                    v-model.number="dateType"
                    row
                    class="mt-1"
                    hide-details
                    :disabled="loading"
                >
                    <v-radio
                        :label="$t('daily-date')"
                        value="daily"
                    ></v-radio>
                    <v-radio
                        :label="$t('from-date') + ' / ' + $t('to-date')"
                        value="custom"
                    ></v-radio>
                </v-radio-group>
            </v-col>

            <!-- filter -->
            <v-col v-if="dateType === 'custom'" align-self="center" cols="12" sm="6" md="2" class="pa-1">
                <bee-date-picker
                    v-model="fromDate"  
                    :label="$t('inputs.start-date')"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        outlined: true,
                        dense: true,
                        clearable: true
                    }"
                    :disabled="loading"
                    :allowed-dates="disableDates"
                ></bee-date-picker>
            </v-col>

            <v-col v-if="dateType === 'custom'" align-self="center" cols="12" sm="6" md="2" class="pa-1">
                <bee-date-picker
                    v-model="toDate"
                    :input-label="$t('inputs.end-date')"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        outlined: true,
                        dense: true,
                        clearable: true
                    }"
                    :disabled="loading"
                    :allowed-dates="disableDates"
                ></bee-date-picker>
            </v-col>

            <v-col v-if="dateType === 'daily'" cols="12" sm="6" md="3" class="pa-1">
                <bee-date-input
                    v-model="date"
                    :append-icon="$i18n.locale === 'en' ? 'mdi-menu-right' : 'mdi-menu-left' "
                    :prepend-icon="$i18n.locale === 'en' ? 'mdi-menu-left' : 'mdi-menu-right' "
                    :label="$t('inputs.date')"
                    input-format-order="DD-MM-YYYY"
                    dense
                    :loading="loading"
                    hide-details
                    @click:append="
                        addDate();
                        fetchAll()
                    "
                    @click:prepend="
                        subDate();
                        fetchAll()
                    "
                ></bee-date-input>
            </v-col>

            <v-col class="pa-1" cols="auto" align-self="center">
                <v-btn-toggle
                    v-model="isConstant"
                    class="mb-1"
                    color="primary"
                    mandatory
                    dense
                    @change="fetchAll()"
                >
                    <v-btn 
                        :disabled="loading" 
                        :value="true" 
                        class="text-none"
                    > 
                        {{ $t('Vacations.recurring-leave') }}
                    </v-btn>
                    <v-btn 
                        :disabled="loading" 
                        :value="false" 
                        class="text-none"
                    >
                        {{ $t('Vacations.one-time-leave') }} 
                    </v-btn>
                </v-btn-toggle>    
            </v-col>

            <v-col cols="auto" align-self="center" class="pa-1">
                <v-btn
                    color="success"
                    class="px-sm-4 mx-2 text-none"
                    :loading="loading"
                    :disabled="loading"
                    small
                    @click="fetchAll"
                >
                    <v-icon> mdi-magnify </v-icon>
                    {{$t('search')}}
                </v-btn>

                <v-btn
                    color="alert-color white--text"
                    class="px-sm-8 text-none"
                    :disabled="loading"
                    small
                    @click="reset(); fetchAll()"
                >
                    {{$t('reset')}}
                </v-btn>

                <v-divider vertical class="mx-1" />

                <v-btn
					small
					class="mx-2"
					color="light-blue white--text"
                    :disabled="loading"
                    @click="dialog = true"
				>                    
					<v-icon class="me-2">
                        mdi-plus-circle-outline
                    </v-icon>
                    {{$t('Vacations.add-new-vacation')}}
                </v-btn>
            </v-col>
        </v-row>
        <!-- table -->
        <bee-handy-table
            :headers="headers"
            :items="vacations"
            dense
            zebra
            :items-per-page="-1"
            hide-default-footer
            :loading="loading"
        >
            <template v-slot:item.isConstant="{ item }">
                <v-chip color="primary" small>
                    {{ item.isConstant ? $t('Vacations.recurring-leave') : $t('Vacations.one-time-leave') }}
                </v-chip>
            </template>

            <!-- actions -->
            <template v-slot:item.actions="{ item }">
                <div>
                    <v-btn
                    	color="edit-color"
                    	icon
                        :disabled="loading"
                    	@click="vacationId = item.id; dialog = true"
                    >
                        <v-icon> mdi-pencil </v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        color="alert-color"
                        :disabled="loading"
                        @click="$refs.deleteDialog.activeDeleteDialog(item.id, 'vacations')"
                    >
                        <v-icon> mdi-delete </v-icon>
                    </v-btn>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
import moment from 'moment'
import { isDisabledFriday, enableVacations } from '@/configs/global.config'
import DeleteDialog from '@/components/DeleteDialog.vue'
import rules from '@/validation rules'
import { mapState } from 'vuex'
import { disableDates } from '@/helpers/functions'
export default {
    data () {
        return {
            dateType: 'daily',
            fromDate: moment(moment().startOf('month')).format('YYYY-MM-DD'),
            toDate: moment(moment().endOf('month')).format('YYYY-MM-DD'),
            date: moment().format('YYYY-MM-DD'),
            isDisabledFriday,
            loading: false,
            isConstant: true,
            dialog: false,
            vacationId: null,
            dataDialog: {
                fromDate: null,
                toDate: null,
                isConstant: false,
                description: null
            },
            submitLoading: false,
            vacations: [],
            rules,
            allowedDays: [],
            disableDates,
            enableVacations
            // disabledDates: [],
        }
    },

    components: {
        DeleteDialog
    },

    watch: {
        dialog(val) {
            if (val) {
                if (this.vacationId) {
                    const vacation = this.vacations.find(c => c.id === this.vacationId)
                    this.dataDialog.fromDate = moment(vacation.fromDate).format('YYYY-MM-DD')
                    this.dataDialog.toDate = moment(vacation.toDate).format('YYYY-MM-DD')
                    this.dataDialog.description = vacation.description
                    this.dataDialog.isConstant = vacation.isConstant
                }
            } else {
                this.dataDialog.fromDate = null
                this.dataDialog.toDate = null
                this.dataDialog.description = null
                this.dataDialog.isConstant = null
                this.vacationId = null
                this.$refs.form.resetValidation()
            }
        }
    },

    computed: {
        headers () {
            return [
                {
                    text: this.$t('headers.description'),
                    name: 'description',
                    value: 'description'
                },
                {
                    text: this.$t('headers.start-date'),
                    name: 'fromDate',
                    value: 'fromDate',
                    setValueExpr: val => moment(val).format('YYYY-MM-DD')
                },
                {
                    text: this.$t('headers.end-date'),
                    name: 'toDate',
                    value: 'toDate',
                    setValueExpr: val => moment(val).format('YYYY-MM-DD')
                },
                {
                    text: this.$t('headers.is-constant'),
                    name: 'isConstant',
                    value: 'isConstant'
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ]
        },

        ...mapState({
            vacationsDayDetails: state => state.vacations.vacationsDayDetails
        })
    },

    methods: {
        moment,
        fetchAll() {
            this.loading = true
            this.$store.dispatch('vacations/fetchVacationByFilters', {
                from: this.dateType === 'custom' ? this.fromDate : this.date,
                to: this.dateType === 'custom' ? this.toDate : this.date,
                onlyConstant: Boolean(this.isConstant)
            }).then((data) => {
                this.vacations = data
            }).finally(() => {
                this.loading = false
            })
        },

        submit () {
            if (this.$refs.form.validate()) {
                this.submitLoading = true
                const actionName = this.vacationId ? 'update' : 'create'
                this.$store.dispatch(`vacations/${actionName}`, { 
                    fromDate: this.dataDialog.fromDate,
                    toDate: this.dataDialog.toDate,
                    isConstant: this.dataDialog.isConstant,
                    description: this.dataDialog.description,
                    id: this.vacationId
                }).then(() => {
                    this.dialog = false
                    this.fetchAll()
                }).finally(() => {
                    this.submitLoading = false
                })
            }
        },

        reset() {
            this.fromDate = null
            this.toDate = null
            this.isConstant = false
            this.description = null
        },

        addDate () {
            this.date = moment(this.date).add(1, 'day').format('YYYY-MM-DD');
            if (
                (this.moment(this.date).format('dddd') === 'Friday' && this.isDisabledFriday) ||
                (this.enableVacations && this.vacationsDayDetails.includes(this.date))
            ) {
                this.addDate()
            }
            return this.date
        },

        subDate() {
            this.date = moment(this.date).subtract(1, 'day').format('YYYY-MM-DD')
            if (
                (this.moment(this.date).format('dddd') === 'Friday' && this.isDisabledFriday) ||
                (this.enableVacations && this.vacationsDayDetails.includes(this.date))
            ) {
                this.subDate()
            }
            return this.date
        }
    },

    created() {
        this.fetchAll()
        if (enableVacations && !this.vacationsDayDetails.length) this.$store.dispatch('vacations/fetchAll')
    }
}
</script>
